import Header from "./Header";
import ServicesSection from "./ServicesSection";
import BottomHeading from "./BottomHeading";

import Ts4 from "../assets/topserve/ts4.jpg";
import Ts5 from "../assets/topserve/ts5.jpg";
import Ts7 from "../assets/topserve/ts7.jpg";
import Ts8 from "../assets/topserve/ts8.jpg";
import TsArrow from "../assets/topserve/ts-arrow.png";

import VidLandscape from "../assets/topserve/ts-vid1-new.mp4";
import VidPortrait1 from "../assets/topserve/ts-vid2-new.mp4";
import VidPortrait2 from "../assets/topserve/ts-vid3-new.mp4";

export default function Topserve() {
  return (
    <div
      style={{ backgroundColor: "#151515" }}
      className="min-h-screen text-white p-5 gap-3"
    >
      <Header />

      {/* Title — TOPSERVE left, subtitle right */}
      <div className="flex flex-row justify-between items-center bg-black my-3 p-4 md:p-8 rounded-lg shadow-lg">
        <h2 className="text-3xl md:text-5xl font-bold text-white">
          TOPSERVE
        </h2>
        <p className="text-sm md:text-2xl text-white text-right font-semibold">
          We designed<br />a community.
        </p>
      </div>

      {/* Hero — full-width brand image */}
      <div className="w-full overflow-hidden rounded-lg shadow-lg mt-2">
        <img
          src={Ts5}
          alt="The Topserve Club"
          className="w-full h-auto"
        />
      </div>

      {/* Tagline 1 */}
      <div className="flex justify-center items-center bg-black mt-2 p-8 rounded-lg shadow-lg text-xl font-bold text-center">
        <span>Building a functional ecosystem to last years</span>
      </div>

      {/* Wide action image */}
      <div className="w-full overflow-hidden rounded-lg shadow-lg mt-5">
        <img
          src={Ts8}
          alt="Topserve in action"
          className="w-full h-auto"
        />
      </div>

      {/* Section heading */}
      <div className="flex justify-center items-center bg-black mt-2 p-8 rounded-lg shadow-lg text-xl font-bold text-center">
        <span>Industrial blueprints and architecture</span>
      </div>

      {/* Video grid — 1 landscape on top, 2 portrait below */}
      <div className="flex flex-col gap-3 mt-5">

        {/* Landscape video — top row, full width, 16:9 crop */}
        <div
          className="w-full overflow-hidden rounded-lg shadow-lg"
          style={{ aspectRatio: "16/9" }}
        >
          <video
            src={VidLandscape}
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover"
          />
        </div>

        {/* Portrait videos — bottom row, 2 side by side, 9:16 crop */}
        <div className="grid grid-cols-2 gap-3">
          <div
            className="overflow-hidden rounded-lg shadow-lg"
            style={{ aspectRatio: "9/16" }}
          >
            <video
              src={VidPortrait1}
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover"
            />
          </div>
          <div
            className="overflow-hidden rounded-lg shadow-lg"
            style={{ aspectRatio: "9/16" }}
          >
            <video
              src={VidPortrait2}
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* Section heading */}
      <div className="flex justify-center items-center bg-black mt-2 p-8 rounded-lg shadow-lg text-xl font-bold text-center">
        <span>Engagement assets for the community</span>
      </div>

      {/* 3-image grid — equal portrait height */}
      <div className="grid grid-cols-3 gap-3 md:gap-4 mt-5">
        <div className="overflow-hidden rounded-lg shadow-lg" style={{ aspectRatio: "3/4" }}>
          <img src={Ts4} alt="Topserve visual 1" className="w-full h-full object-cover" />
        </div>
        <div className="overflow-hidden rounded-lg shadow-lg" style={{ aspectRatio: "3/4" }}>
          <img src={Ts7} alt="Topserve visual 2" className="w-full h-full object-cover" />
        </div>
        <div className="overflow-hidden rounded-lg shadow-lg" style={{ aspectRatio: "3/4" }}>
          <img src={Ts5} alt="Topserve visual 3" className="w-full h-full object-cover" />
        </div>
      </div>

      {/* Footer CTA */}
      <BottomHeading
        title="Go to Justt. Essentials"
        subtitle={TsArrow}
        subtitle2="The new way to take your daily supplements"
        redirectUrl="/dukaan"
      />

      <ServicesSection />
    </div>
  );
}
